import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import PageTransition from '../components/templates/PageTransition';
import SEO from '../components/utils/SEO';

const NotFound = () => {
    return (
        <PageTransition>
            <SEO title="Page Not Found" description="The page you are looking for does not exist." />
            <div className="bg-[#050505] text-[#fbfbf4] font-sans selection:bg-[#fbfbf4] selection:text-[#050505] min-h-screen flex flex-col items-center justify-center relative overflow-hidden px-6">

                <h1 className="font-sans font-black text-[25vw] leading-[0.8] tracking-tighter opacity-10 select-none pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap">
                    404 404
                </h1>

                <div className="relative z-10 text-center max-w-lg">
                    <span className="block text-xs uppercase tracking-[0.2em] opacity-50 mb-6 animate-pulse">Error code 404</span>
                    <h2 className="font-migra text-5xl md:text-7xl mb-8">Lost in the<br /><span className="italic opacity-50">void.</span></h2>
                    <p className="text-lg opacity-60 mb-12 font-light">
                        The digital coordinates you entered point to nowhere. Let's get you back to solid ground.
                    </p>

                    <Link to="/" className="inline-flex items-center gap-3 bg-white text-black px-8 py-4 rounded-full font-bold text-xs tracking-widest uppercase hover:scale-105 transition-transform">
                        Return Home <ArrowUpRight size={16} />
                    </Link>
                </div>

            </div>
        </PageTransition>
    );
};

export default NotFound;
